<span *ngIf="titleLabel" class="pr-2 text-uppercase">{{titleLabel}}</span>
<input type="radio" value="list" name="viewMode" [(ngModel)]="viewMode" checked id="radioListView"
  (ngModelChange)="onChange($event)" kendoRadioButton />
<label class="k-radio-label" for="radioListView">{{'LIST-VIEW' | translate}}</label>
<input type="radio" value="{{contextMode}}" name="viewMode" [(ngModel)]="viewMode" class="ml-3" checked id="radioView"
  (ngModelChange)="onChange($event)" kendoRadioButton />
<label class="k-radio-label" for="radioView">{{ (contextMode === 'calendar' ? 'CALENDAR-VIEW' : 'CARD-VIEW') |
  translate}}</label>